import { Component, EventEmitter, Input, Output } from '@angular/core';

import { KydCustomerDataModel } from '../../../../core/store/programs/kyd-smartphone/models/kyd-smartphone-policy.model';

@Component({
  selector: 'ds-kyd-smartphone-unenroll-one-modal',
  templateUrl: './kyd-smartphone-unenroll-one-modal.component.html',
  standalone: false
})
export class KydSmartphoneUnenrollOneModalComponent {
  @Input() isLastOperator: boolean;
  @Input() operatorName: string;
  @Input() policyState: string;
  @Output() unEnrollOne = new EventEmitter<any>();
  @Output() closeModal = new EventEmitter<string>();

  public modalId = 'unenroll-one-modal';
}
